import React from 'react';
import { styled } from '@slicknode/stylemapper';
import { twMerge } from 'tailwind-merge';

type CountdownVariant = 'landingPage' | 'release' | 'feedReleaseDropped';

const CountdownNumber = styled('p', 'font-numerals text-numerals-s text-white h-fit', {
  variants: {
    small: {
      true: 'text-numerals-2xs',
      false: '',
    },
    variant: {
      feedReleaseDropped: 'text-numerals-2xs',
      release: 'text-white',
      landingPage: 'text-white',
    },
  },
});

const CoundowntLabel = styled('span', 'font-base text-base-xs uppercase font-semibold text-white', {
  variants: {
    small: {
      true: 'hidden',
      false: '',
    },
  },
});

const Colon = styled('div', 'flex justify-center font-numerals text-numerals-s', {
  variants: {
    fuschia: {
      true: 'bg-fuchsia bg-clip-text fill-transparent text-transparent',
      false: '',
    },
    variant: {
      feedReleaseDropped: 'text-numerals-2xs text-white',
      release: 'text-white',
      landingPage: 'text-white',
    },
  },
});

const FullCountdownContainer = styled(
  'div',
  'grid grid-cols-7 my-0 mx-auto max-w-[264px] md:p-0 md:backdrop-filter-none md:rounded-none md:shadow-transparent md:max-w-[337px]',
  {
    variants: {
      fuschia: {
        true: 'text-fuchsia500',
        false: '',
      },
      small: {
        true: 'pr-0 w-full',
        false: '',
      },
      variant: {
        feedReleaseDropped: ' text-white',
        release: 'text-white md:mb-[34px] mb:mt-1',
        landingPage: 'mt-6 mb-0',
      },
    },
  },
);

const HeroCountdownNumber = ({
  variant,
  value,
  label,
  isLast,
  fuschia,
  small,
}: {
  variant: CountdownVariant;
  value: number;
  label: string;
  fuschia?: boolean;
  isLast?: boolean;
  small?: boolean;
}) => {
  return (
    <>
      <div
        className={twMerge(
          'flex flex-col items-center gap-y-1.5 rounded-xl',
          fuschia && 'rounded-none bg-fuchsia bg-clip-text fill-transparent text-transparent',
        )}
      >
        <CountdownNumber variant={variant} small={small} suppressHydrationWarning>
          {String(value).padStart(2, '0')}
        </CountdownNumber>
        <CoundowntLabel small={small}>{label}</CoundowntLabel>
      </div>
      {!isLast && (
        <Colon variant={variant} fuschia={!!fuschia}>
          :
        </Colon>
      )}
    </>
  );
};

// Missing Test
// TODO: https://linear.app/sound/issue/ENG-2492/add-tests-for-listeningpartycountdown
export const ListeningPartyCountdown = ({
  seconds,
  minutes,
  hours,
  days,
  fuschia,
  variant = 'release',
  small,
}: {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
  fuschia?: boolean;
  variant?: CountdownVariant;
  small?: boolean;
}) => {
  return (
    <FullCountdownContainer variant={variant} fuschia={fuschia} small={small}>
      <HeroCountdownNumber
        variant={variant}
        fuschia={fuschia}
        value={days}
        label="days"
        small={small}
      />
      <HeroCountdownNumber
        variant={variant}
        fuschia={fuschia}
        value={hours}
        label="hrs"
        small={small}
      />
      <HeroCountdownNumber
        variant={variant}
        fuschia={fuschia}
        value={minutes}
        label="min"
        small={small}
      />
      <HeroCountdownNumber
        variant={variant}
        fuschia={fuschia}
        value={seconds}
        label="sec"
        isLast
        small={small}
      />
    </FullCountdownContainer>
  );
};
